<template>
    <v-menu
        v-model="show"
        :position-x="x"
        :position-y="y"
        absolute
    >
        <div class="fci-list">
            <template v-for="group in actionList">
                <div :key="group.name" class="fci-list-group">{{ group.name }}</div>
                <div
                    v-for="action in group.children"
                    :key="action.name"
                    class="fci-list-item"
                    :class="{active: graphType === action.graphType, disabled: !!action.disabled}"
                    @click="onAction(action.action)"
                >
                    <Icon :name="action.icon" style="margin-right: 5px"></Icon>
                    {{ action.name }}
                    <v-flex></v-flex>
                    <Icon name="CheckBoxCircle" class="ml-3" v-if="graphType === action.graphType"></Icon>
                </div>
            </template>
        </div>
    </v-menu>
</template>

<script>
import { GraphType, NodeContextMenuAction } from '@/utils/const'
import Icon from '@/components/icons/Icon'
import { mapState } from 'vuex'
export default {
    name: 'NodeContextMenu',
    components: { Icon },
    data () {
        return {
            Action: NodeContextMenuAction,
            show: false,
            x: 0,
            y: 0,
            item: null,
            graphType: null
        }
    },
    computed: {
        ...mapState('scenario', ['scenarioList', 'stepList']),
        actionList () {
            return [
                {
                    name: this.$f.tc('action'),
                    children: [
                        {
                            name: this.$f.tc('rename'),
                            icon: 'Edit',
                            action: NodeContextMenuAction.RENAME,
                            disabled: this.isDefaultStep(this.item)
                        },
                        {
                            name: this.$f.tc('delete'),
                            icon: 'Delete',
                            action: NodeContextMenuAction.DELETE,
                            disabled: this.isDefaultStep(this.item)
                        }
                    ]
                },
                {
                    name: this.$f.tc('flow'),
                    children: [
                        {
                            name: this.$f.tc('flowStandard'),
                            icon: 'FlowGraphStandard',
                            action: NodeContextMenuAction.FLOW_STANDARD,
                            graphType: GraphType.FLOW_STANDARD
                        },
                        {
                            name: this.$f.tc('flowContainNode'),
                            icon: 'FlowChartContain',
                            action: NodeContextMenuAction.FLOW_CONTAIN_NODE,
                            graphType: GraphType.FLOW_CONTAIN_NODE
                        },
                        {
                            name: this.$f.tc('flowFromNode'),
                            icon: 'FlowChartFrom',
                            action: NodeContextMenuAction.FLOW_FROM_NODE,
                            graphType: GraphType.FLOW_FROM_NODE,
                            disabled: this.item && this.item.data.children < 1
                        },
                        {
                            name: this.$f.tc('flowToNode'),
                            icon: 'FlowChartTo',
                            action: NodeContextMenuAction.FLOW_TO_NODE,
                            graphType: GraphType.FLOW_TO_NODE,
                            disabled: this.item && this.item.data.parent === null
                        }
                    ]
                }
            ]
        }
    },
    methods: {
        open (event, item, graphType) {
            this.x = event.x
            this.y = event.y
            this.show = true
            this.item = item
            this.graphType = graphType
        },
        close () {
            this.show = false
        },
        isDefaultStep (item) {
            const scenarioSet = new Set(
                this.scenarioList
                    .filter(scenario => scenario.position === 1)
                    .map(scenario => scenario.code)
            )

            for (let step of this.stepList) {
                if (item && step.code === item.id && scenarioSet.has(step.scenario_code)) {
                    return true
                }
            }
            return false
        },
        onAction (actionName) {
            this.$emit('action', {
                name: actionName,
                item: this.item
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/fci-var";

.fci-list {
    min-width: 180px;
}

.fci-list-group {
    background: $borderColor2;
    color: $textColor3;
    font-size: 12px;
}

.fci-list-item {
    padding: 5px;

    &.active {
        background: $primary3;
        color: $primary1;

        &::v-deep path {
            fill: $primary1;
        }
    }
}
</style>
